
export default [
  {
    "content": "# Character AI\n\nCharacter AI offers free and paid tiers with different message limits and early feature access.\n\n## References\n\n[^1]: https://character.ai\n[^2]: https://r.jina.ai/https://en.wikipedia.org/wiki/Character.AI\n[^3]: https://www.cnbc.com/2023/05/09/character-ai-launches-9-99-subscription-service.html\n[^4]: https://techcrunch.com/2023/05/09/character-ai-launches-plus-subscription\n[^5]: https://www.engadget.com/character-ai-plus-launches-with-priority-access-early-features-150000000.html",
    "title": "Character AI",
    "description": "Quick pricing and feature summary comparing Character AI's free and Plus tiers for chat and voice.",
    "date": new Date("2023-05-09T00:00:00.000Z"),
    "tag": "Chatbot",
    "tiers": [
      {
        "name": "Free",
        "price": "Free",
        "model": "Character AI",
        "features": [
          "chat with custom and community characters",
          "limited voice support"
        ]
      },
      {
        "name": "Plus",
        "price": "$9.99",
        "model": "Character AI",
        "features": [
          "faster responses",
          "priority access to new features",
          "more daily messages"
        ]
      }
    ],
    "_meta": {
      "filePath": "character-ai.mdx",
      "fileName": "character-ai.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "character-ai"
    },
    "author": "Benched.ai Editorial Team",
    "body": "var Component=(()=>{var m=Object.create;var a=Object.defineProperty;var l=Object.getOwnPropertyDescriptor;var u=Object.getOwnPropertyNames;var x=Object.getPrototypeOf,_=Object.prototype.hasOwnProperty;var p=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),j=(e,n)=>{for(var r in n)a(e,r,{get:n[r],enumerable:!0})},i=(e,n,r,c)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let s of u(n))!_.call(e,s)&&s!==r&&a(e,s,{get:()=>n[s],enumerable:!(c=l(n,s))||c.enumerable});return e};var C=(e,n,r)=>(r=e!=null?m(x(e)):{},i(n||!e||!e.__esModule?a(r,\"default\",{value:e,enumerable:!0}):r,e)),g=e=>i(a({},\"__esModule\",{value:!0}),e);var h=p((y,o)=>{o.exports=_jsx_runtime});var M={};j(M,{default:()=>f});var t=C(h());function d(e){let n={h1:\"h1\",h2:\"h2\",p:\"p\",...e.components};return(0,t.jsxs)(t.Fragment,{children:[(0,t.jsx)(n.h1,{children:\"Character AI\"}),`\n`,(0,t.jsx)(n.p,{children:\"Character AI offers free and paid tiers with different message limits and early feature access.\"}),`\n`,(0,t.jsx)(n.h2,{children:\"References\"})]})}function f(e={}){let{wrapper:n}=e.components||{};return n?(0,t.jsx)(n,{...e,children:(0,t.jsx)(d,{...e})}):d(e)}return g(M);})();\n;return Component;",
    "slug": "character-ai",
    "readingTime": "1 min read"
  },
  {
    "content": "# ChatGPT\n\nChatGPT offers Free, Plus, and Pro tiers with better models, extra features, and higher reliability.\n\n## References\n\n[^1]: https://web.archive.org/web/20240419053820/https://openai.com/blog/chatgpt\n\n[^2]: https://raw.githubusercontent.com/openai/openai-cookbook/main/README.md\n\n[^3]: https://web.archive.org/web/20230201235213/https://openai.com/blog/chatgpt-plus\n\n[^4]: https://r.jina.ai/https://en.wikipedia.org/wiki/ChatGPT\n\n[^5]: https://www.theverge.com/2023/11/6/23950532/openai-chatgpt-plus-features-updates-subscription\n\n[^6]: https://r.jina.ai/https://openai.com/blog/introducing-chatgpt-pro",
    "title": "ChatGPT",
    "description": "Simple overview of ChatGPT's Free, Plus, and Pro prices, features, and model access.",
    "date": new Date("2022-11-30T00:00:00.000Z"),
    "tag": "Assistant",
    "tiers": [
      {
        "name": "Free (Logged Out)",
        "price": "Free",
        "model": "GPT-4o mini",
        "features": [
          "Basic chat with no login",
          "limited history"
        ]
      },
      {
        "name": "Free (Logged In)",
        "price": "Free",
        "model": "GPT-4o (Aug '24)",
        "features": [
          "Chat history",
          "more tools than logged out tier"
        ]
      },
      {
        "name": "Plus",
        "price": "$20.00",
        "model": "GPT-4o (Aug '24)",
        "features": [
          "Faster service",
          "priority access",
          "extra features"
        ]
      },
      {
        "name": "Pro",
        "price": "$200.00",
        "model": "OpenAI o1",
        "features": [
          "Unlimited o1, o1-mini, GPT-4o, and Advanced Voice",
          "o1 pro mode uses more compute",
          "compute-intensive features coming"
        ]
      }
    ],
    "_meta": {
      "filePath": "chatgpt.mdx",
      "fileName": "chatgpt.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "chatgpt"
    },
    "author": "Benched.ai Editorial Team",
    "body": "var Component=(()=>{var m=Object.create;var o=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var x=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,_=Object.prototype.hasOwnProperty;var j=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports),p=(e,n)=>{for(var r in n)o(e,r,{get:n[r],enumerable:!0})},h=(e,n,r,a)=>{if(n&&typeof n==\"object\"||typeof n==\"function\")for(let s of x(n))!_.call(e,s)&&s!==r&&o(e,s,{get:()=>n[s],enumerable:!(a=u(n,s))||a.enumerable});return e};var C=(e,n,r)=>(r=e!=null?m(f(e)):{},h(n||!e||!e.__esModule?o(r,\"default\",{value:e,enumerable:!0}):r,e)),P=e=>h(o({},\"__esModule\",{value:!0}),e);var c=j((M,i)=>{i.exports=_jsx_runtime});var g={};p(g,{default:()=>l});var t=C(c());function d(e){let n={h1:\"h1\",h2:\"h2\",p:\"p\",...e.components};return(0,t.jsxs)(t.Fragment,{children:[(0,t.jsx)(n.h1,{children:\"ChatGPT\"}),`\n`,(0,t.jsx)(n.p,{children:\"ChatGPT offers Free, Plus, and Pro tiers with better models, extra features, and higher reliability.\"}),`\n`,(0,t.jsx)(n.h2,{children:\"References\"})]})}function l(e={}){let{wrapper:n}=e.components||{};return n?(0,t.jsx)(n,{...e,children:(0,t.jsx)(d,{...e})}):d(e)}return P(g);})();\n;return Component;",
    "slug": "chatgpt",
    "readingTime": "1 min read"
  },
  {
    "content": "# Claude\n\nClaude Free, Pro, and Max provide increasing usage tiers, larger context, and access to better models.[^1][^2][^3][^4][^5]\n\n## References\n\n[^1]: https://www.anthropic.com/help/about-claude-pro-usage\n[^2]: https://www.anthropic.com/help/about-claude-max-plan-usage\n[^3]: https://www.anthropic.com/help/using-claude-code-with-your-pro-or-max-plan\n[^4]: https://www.anthropic.com/help/how-rate-limits-work-using-research-in-the-max-plan\n[^5]: https://www.anthropic.com/help/claude-code-usage-limits-and-billing",
    "title": "Claude",
    "description": "Quick overview of Claude's Free, Pro, and Max pricing tiers with message limits and model access.",
    "date": new Date("2023-03-14T00:00:00.000Z"),
    "tag": "Assistant",
    "tiers": [
      {
        "name": "Free",
        "price": "Free",
        "model": "Claude 3.5 Sonnet (June)",
        "features": [
          "7 messages each hour",
          "13k context window",
          "no code or advanced tools"
        ]
      },
      {
        "name": "Pro",
        "price": "$20.00",
        "model": "Claude 3.5 Sonnet (June)",
        "features": [
          "45 messages per five hours",
          "200k context window",
          "limited Claude Code prompts"
        ]
      },
      {
        "name": "Max",
        "price": "$100.00-$200.00",
        "model": "Claude 3.5 Sonnet or Opus 4",
        "features": [
          "225-900 messages per five hours",
          "200k context window",
          "early Opus access and research features"
        ]
      }
    ],
    "_meta": {
      "filePath": "claude.mdx",
      "fileName": "claude.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "claude"
    },
    "author": "Benched.ai Editorial Team",
    "body": "var Component=(()=>{var h=Object.create;var o=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var p=Object.getOwnPropertyNames;var b=Object.getPrototypeOf,m=Object.prototype.hasOwnProperty;var w=(t,e)=>()=>(e||t((e={exports:{}}).exports,e),e.exports),k=(t,e)=>{for(var r in e)o(t,r,{get:e[r],enumerable:!0})},i=(t,e,r,c)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let a of p(e))!m.call(t,a)&&a!==r&&o(t,a,{get:()=>e[a],enumerable:!(c=u(e,a))||c.enumerable});return t};var x=(t,e,r)=>(r=t!=null?h(b(t)):{},i(e||!t||!t.__esModule?o(r,\"default\",{value:t,enumerable:!0}):r,t)),g=t=>i(o({},\"__esModule\",{value:!0}),t);var f=w((_,l)=>{l.exports=_jsx_runtime});var y={};k(y,{default:()=>s});var n=x(f());function d(t){let e={a:\"a\",h1:\"h1\",h2:\"h2\",li:\"li\",ol:\"ol\",p:\"p\",section:\"section\",sup:\"sup\",...t.components};return(0,n.jsxs)(n.Fragment,{children:[(0,n.jsx)(e.h1,{children:\"Claude\"}),`\n`,(0,n.jsxs)(e.p,{children:[\"Claude Free, Pro, and Max provide increasing usage tiers, larger context, and access to better models.\",(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-1\",id:\"user-content-fnref-1\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"1\"})}),(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-2\",id:\"user-content-fnref-2\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"2\"})}),(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-3\",id:\"user-content-fnref-3\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"3\"})}),(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-4\",id:\"user-content-fnref-4\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"4\"})}),(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-5\",id:\"user-content-fnref-5\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"5\"})})]}),`\n`,(0,n.jsx)(e.h2,{children:\"References\"}),`\n`,(0,n.jsxs)(e.section,{\"data-footnotes\":!0,className:\"footnotes\",children:[(0,n.jsx)(e.h2,{className:\"sr-only\",id:\"footnote-label\",children:\"References\"}),`\n`,(0,n.jsxs)(e.ol,{children:[`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-1\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://www.anthropic.com/help/about-claude-pro-usage\",children:\"anthropic.com\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-1\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 1\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-2\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://www.anthropic.com/help/about-claude-max-plan-usage\",children:\"anthropic.com\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-2\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 2\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-3\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://www.anthropic.com/help/using-claude-code-with-your-pro-or-max-plan\",children:\"anthropic.com\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-3\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 3\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-4\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://www.anthropic.com/help/how-rate-limits-work-using-research-in-the-max-plan\",children:\"anthropic.com\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-4\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 4\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-5\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://www.anthropic.com/help/claude-code-usage-limits-and-billing\",children:\"anthropic.com\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-5\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 5\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`]}),`\n`]})]})}function s(t={}){let{wrapper:e}=t.components||{};return e?(0,n.jsx)(e,{...t,children:(0,n.jsx)(d,{...t})}):d(t)}return g(y);})();\n;return Component;",
    "slug": "claude",
    "readingTime": "1 min read"
  },
  {
    "content": "# Gemini\n\nGemini offers a free plan and a paid advanced plan with different models and perks.\n\n## References\n\n[^1]: https://blog.google/technology/ai/gemini-advanced\n\n[^2]: https://support.google.com/googleone/answer/13512811\n\n[^3]: https://deepmind.google/technologies/gemini\n\n[^4]: https://r.jina.ai/https://en.wikipedia.org/wiki/Gemini_%28language_model%29\n\n[^5]: https://www.theverge.com/2024/2/8/google-gemini-advanced-pricing",
    "title": "Gemini",
    "description": "Overview of Gemini's free and advanced plans with prices, models, and notable features.",
    "date": new Date("2024-02-08T00:00:00.000Z"),
    "tag": "Assistant",
    "tiers": [
      {
        "name": "Free",
        "price": "Free",
        "model": "Gemini 1.5 Flash (May)",
        "features": [
          "Basic chat access",
          "limited usage and features"
        ]
      },
      {
        "name": "Advanced",
        "price": "$19.99",
        "model": "Gemini 1.5 Pro (May)",
        "features": [
          "Priority access to powerful model",
          "early feature releases"
        ]
      }
    ],
    "_meta": {
      "filePath": "gemini.mdx",
      "fileName": "gemini.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "gemini"
    },
    "author": "Benched.ai Editorial Team",
    "body": "var Component=(()=>{var f=Object.create;var s=Object.defineProperty;var l=Object.getOwnPropertyDescriptor;var p=Object.getOwnPropertyNames;var x=Object.getPrototypeOf,u=Object.prototype.hasOwnProperty;var _=(n,e)=>()=>(e||n((e={exports:{}}).exports,e),e.exports),j=(n,e)=>{for(var r in e)s(n,r,{get:e[r],enumerable:!0})},o=(n,e,r,i)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let a of p(e))!u.call(n,a)&&a!==r&&s(n,a,{get:()=>e[a],enumerable:!(i=l(e,a))||i.enumerable});return n};var M=(n,e,r)=>(r=n!=null?f(x(n)):{},o(e||!n||!n.__esModule?s(r,\"default\",{value:n,enumerable:!0}):r,n)),g=n=>o(s({},\"__esModule\",{value:!0}),n);var d=_((D,c)=>{c.exports=_jsx_runtime});var w={};j(w,{default:()=>m});var t=M(d());function h(n){let e={h1:\"h1\",h2:\"h2\",p:\"p\",...n.components};return(0,t.jsxs)(t.Fragment,{children:[(0,t.jsx)(e.h1,{children:\"Gemini\"}),`\n`,(0,t.jsx)(e.p,{children:\"Gemini offers a free plan and a paid advanced plan with different models and perks.\"}),`\n`,(0,t.jsx)(e.h2,{children:\"References\"})]})}function m(n={}){let{wrapper:e}=n.components||{};return e?(0,t.jsx)(e,{...n,children:(0,t.jsx)(h,{...n})}):h(n)}return g(w);})();\n;return Component;",
    "slug": "gemini",
    "readingTime": "1 min read"
  },
  {
    "content": "# Grok\n\nGrok offers four consumer tiers ranging from a limited free plan to the SuperGrok power-user option[^1]. Free users face tight caps and must have a verified X account over a week old[^2][^3]. X Premium includes basic social perks and moderate Grok access[^4]. Premium+ costs more but adds full Think mode, faster service, and voice chat[^5]. SuperGrok strips social features yet grants Big Brain, DeepSearch, and early model betas at a lower price than Premium+[^6][^7]. Musk warns the free period lasts only \"until our servers melt\"[^8].\n\n## References\n\n[^1]: https://tech.co/news/grok-ai-pricing\n\n[^2]: https://www.reddit.com/r/grok/comments/1jpjmy6/free_tier_limits_as_of_2nd_april_2025/\n\n[^3]: https://www.mindstream.news/p/grok-is-now-free-sorta\n\n[^4]: https://tech.co/news/grok-ai-pricing\n\n[^5]: https://www.pcworld.com/article/2613077/x-nearly-doubles-the-price-of-premium-plan-after-grok-3-ai-update.html\n\n[^6]: https://daily.dev/blog/grok-3-everything-you-need-to-know-about-this-new-llm-by-xai\n\n[^7]: https://builtin.com/artificial-intelligence/grok-3\n\n[^8]: https://tech.co/news/grok-ai-pricing",
    "title": "Grok",
    "description": "Snapshot of Grok's Free, Premium, Premium+, and SuperGrok tiers with key limits, pricing, and exclusive features.",
    "date": new Date("2023-11-04T00:00:00.000Z"),
    "tag": "Assistant",
    "categories": {
      "performance": {
        "price": "Free",
        "foundationModel": "Grok-3",
        "intelligence": "70",
        "rateLimit": "High",
        "speed": "Slow",
        "timeToFirstToken": "",
        "outputSpeed": "",
        "contextWindow": "3k"
      },
      "capabilities": {
        "image": {
          "imageGeneration": "Yes",
          "imageModel": "",
          "imageModelRanking": ""
        },
        "input": {
          "inputCapabilities": "0/4",
          "imageUpload": "",
          "pdfUpload": "",
          "excelCsvUpload": "",
          "fileSourceConnect": ""
        },
        "voice": {
          "voiceFeatures": "1/3",
          "voiceInput": "",
          "voiceConversation": "",
          "nativeVoiceToVoice": ""
        },
        "tools": "1/4"
      },
      "memoryHistory": {
        "memory": "1/2",
        "chatHistory": ""
      },
      "apps": {
        "ios": "",
        "android": "",
        "mac": "",
        "windows": ""
      },
      "other": {
        "notes": "",
        "trainingDataSharingPolicy": "",
        "trainingDataSharingPolicySource": ""
      }
    },
    "tiers": [
      {
        "name": "Free",
        "price": "Free",
        "model": "Grok-3",
        "features": [
          "10-12 prompts every two hours",
          "small daily image quota",
          "phone-verified X account over seven days old",
          "no Think or Big Brain access"
        ]
      },
      {
        "name": "X Premium",
        "price": "$8.00",
        "model": "Grok-3",
        "features": [
          "roughly one hundred text prompts every two hours",
          "limited Think prompts",
          "DeepSearch disabled",
          "includes standard X social perks"
        ]
      },
      {
        "name": "X Premium+",
        "price": "$40.00",
        "model": "Grok-3",
        "features": [
          "high usage caps with priority queue",
          "full Think mode access",
          "voice mode beta",
          "ad-free X experience"
        ]
      },
      {
        "name": "SuperGrok",
        "price": "$30.00",
        "model": "Grok-3 and betas",
        "features": [
          "Big Brain reasoning",
          "unlimited DeepSearch and images",
          "earliest model previews like Grok-3.5",
          "discount for Premium+ subscribers"
        ]
      }
    ],
    "_meta": {
      "filePath": "grok.mdx",
      "fileName": "grok.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "grok"
    },
    "author": "Benched.ai Editorial Team",
    "body": "var Component=(()=>{var h=Object.create;var o=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var b=Object.getOwnPropertyNames;var p=Object.getPrototypeOf,m=Object.prototype.hasOwnProperty;var k=(r,e)=>()=>(e||r((e={exports:{}}).exports,e),e.exports),w=(r,e)=>{for(var t in e)o(r,t,{get:e[t],enumerable:!0})},i=(r,e,t,c)=>{if(e&&typeof e==\"object\"||typeof e==\"function\")for(let a of b(e))!m.call(r,a)&&a!==t&&o(r,a,{get:()=>e[a],enumerable:!(c=u(e,a))||c.enumerable});return r};var g=(r,e,t)=>(t=r!=null?h(p(r)):{},i(e||!r||!r.__esModule?o(t,\"default\",{value:r,enumerable:!0}):t,r)),y=r=>i(o({},\"__esModule\",{value:!0}),r);var l=k((B,f)=>{f.exports=_jsx_runtime});var _={};w(_,{default:()=>s});var n=g(l());function d(r){let e={a:\"a\",h1:\"h1\",h2:\"h2\",li:\"li\",ol:\"ol\",p:\"p\",section:\"section\",sup:\"sup\",...r.components};return(0,n.jsxs)(n.Fragment,{children:[(0,n.jsx)(e.h1,{children:\"Grok\"}),`\n`,(0,n.jsxs)(e.p,{children:[\"Grok offers four consumer tiers ranging from a limited free plan to the SuperGrok power-user option\",(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-1\",id:\"user-content-fnref-1\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"1\"})}),\". Free users face tight caps and must have a verified X account over a week old\",(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-2\",id:\"user-content-fnref-2\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"2\"})}),(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-3\",id:\"user-content-fnref-3\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"3\"})}),\". X Premium includes basic social perks and moderate Grok access\",(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-4\",id:\"user-content-fnref-4\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"4\"})}),\". Premium+ costs more but adds full Think mode, faster service, and voice chat\",(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-5\",id:\"user-content-fnref-5\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"5\"})}),\". SuperGrok strips social features yet grants Big Brain, DeepSearch, and early model betas at a lower price than Premium+\",(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-6\",id:\"user-content-fnref-6\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"6\"})}),(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-7\",id:\"user-content-fnref-7\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"7\"})}),'. Musk warns the free period lasts only \"until our servers melt\"',(0,n.jsx)(e.sup,{children:(0,n.jsx)(e.a,{href:\"#user-content-fn-8\",id:\"user-content-fnref-8\",\"data-footnote-ref\":!0,\"aria-describedby\":\"footnote-label\",children:\"8\"})}),\".\"]}),`\n`,(0,n.jsx)(e.h2,{children:\"References\"}),`\n`,(0,n.jsxs)(e.section,{\"data-footnotes\":!0,className:\"footnotes\",children:[(0,n.jsx)(e.h2,{className:\"sr-only\",id:\"footnote-label\",children:\"References\"}),`\n`,(0,n.jsxs)(e.ol,{children:[`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-1\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://tech.co/news/grok-ai-pricing\",children:\"tech.co\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-1\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 1\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-2\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://www.reddit.com/r/grok/comments/1jpjmy6/free_tier_limits_as_of_2nd_april_2025/\",children:\"reddit.com\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-2\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 2\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-3\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://www.mindstream.news/p/grok-is-now-free-sorta\",children:\"mindstream.news\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-3\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 3\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-4\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://tech.co/news/grok-ai-pricing\",children:\"tech.co\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-4\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 4\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-5\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://www.pcworld.com/article/2613077/x-nearly-doubles-the-price-of-premium-plan-after-grok-3-ai-update.html\",children:\"pcworld.com\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-5\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 5\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-6\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://daily.dev/blog/grok-3-everything-you-need-to-know-about-this-new-llm-by-xai\",children:\"daily.dev\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-6\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 6\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-7\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://builtin.com/artificial-intelligence/grok-3\",children:\"builtin.com\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-7\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 7\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`,(0,n.jsxs)(e.li,{id:\"user-content-fn-8\",children:[`\n`,(0,n.jsxs)(e.p,{children:[(0,n.jsx)(e.a,{href:\"https://tech.co/news/grok-ai-pricing\",children:\"tech.co\"}),\" \",(0,n.jsx)(e.a,{href:\"#user-content-fnref-8\",\"data-footnote-backref\":\"\",\"aria-label\":\"Back to reference 8\",className:\"data-footnote-backref\",children:\"\\u21A9\"})]}),`\n`]}),`\n`]}),`\n`]})]})}function s(r={}){let{wrapper:e}=r.components||{};return e?(0,n.jsx)(e,{...r,children:(0,n.jsx)(d,{...r})}):d(r)}return y(_);})();\n;return Component;",
    "slug": "grok",
    "readingTime": "1 min read"
  },
  {
    "content": "# HuggingChat\n\nContent for HuggingChat.",
    "date": new Date("2023-04-28T00:00:00.000Z"),
    "tag": "Chatbot",
    "categories": {
      "performance": {
        "price": "Free",
        "foundationModel": "Llama 3.1 70B",
        "intelligence": "35.4",
        "rateLimit": "High",
        "speed": "Slow",
        "timeToFirstToken": "",
        "outputSpeed": "",
        "contextWindow": "8k"
      },
      "capabilities": {
        "image": {
          "imageGeneration": "Yes",
          "imageModel": "",
          "imageModelRanking": ""
        },
        "input": {
          "inputCapabilities": "3/4",
          "imageUpload": "",
          "pdfUpload": "",
          "excelCsvUpload": "",
          "fileSourceConnect": ""
        },
        "voice": {
          "voiceFeatures": "0/3",
          "voiceInput": "",
          "voiceConversation": "",
          "nativeVoiceToVoice": ""
        },
        "tools": "0/4"
      },
      "memoryHistory": {
        "memory": "1/2",
        "chatHistory": ""
      },
      "apps": {
        "ios": "",
        "android": "",
        "mac": "",
        "windows": ""
      },
      "other": {
        "notes": "",
        "trainingDataSharingPolicy": "",
        "trainingDataSharingPolicySource": ""
      }
    },
    "_meta": {
      "filePath": "huggingchat.mdx",
      "fileName": "huggingchat.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "huggingchat"
    },
    "title": "HuggingChat",
    "author": "Benched.ai Editorial Team",
    "body": "var Component=(()=>{var m=Object.create;var s=Object.defineProperty;var x=Object.getOwnPropertyDescriptor;var _=Object.getOwnPropertyNames;var d=Object.getPrototypeOf,f=Object.prototype.hasOwnProperty;var j=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),l=(n,t)=>{for(var o in t)s(n,o,{get:t[o],enumerable:!0})},a=(n,t,o,c)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let r of _(t))!f.call(n,r)&&r!==o&&s(n,r,{get:()=>t[r],enumerable:!(c=x(t,r))||c.enumerable});return n};var p=(n,t,o)=>(o=n!=null?m(d(n)):{},a(t||!n||!n.__esModule?s(o,\"default\",{value:n,enumerable:!0}):o,n)),C=n=>a(s({},\"__esModule\",{value:!0}),n);var h=j((F,i)=>{i.exports=_jsx_runtime});var M={};l(M,{default:()=>g});var e=p(h());function u(n){let t={h1:\"h1\",p:\"p\",...n.components};return(0,e.jsxs)(e.Fragment,{children:[(0,e.jsx)(t.h1,{children:\"HuggingChat\"}),`\n`,(0,e.jsx)(t.p,{children:\"Content for HuggingChat.\"})]})}function g(n={}){let{wrapper:t}=n.components||{};return t?(0,e.jsx)(t,{...n,children:(0,e.jsx)(u,{...n})}):u(n)}return C(M);})();\n;return Component;",
    "slug": "huggingchat",
    "readingTime": "1 min read"
  },
  {
    "content": "# Meta AI\n\nContent for Meta AI.",
    "date": new Date("2024-04-18T00:00:00.000Z"),
    "tag": "Chatbot",
    "categories": {
      "performance": {
        "price": "Free",
        "foundationModel": "Llama 3.1 405B",
        "intelligence": "40.5",
        "rateLimit": "High",
        "speed": "Fairly fast",
        "timeToFirstToken": "",
        "outputSpeed": "",
        "contextWindow": "2k"
      },
      "capabilities": {
        "image": {
          "imageGeneration": "Yes",
          "imageModel": "",
          "imageModelRanking": ""
        },
        "input": {
          "inputCapabilities": "0/4",
          "imageUpload": "",
          "pdfUpload": "",
          "excelCsvUpload": "",
          "fileSourceConnect": ""
        },
        "voice": {
          "voiceFeatures": "0/3",
          "voiceInput": "",
          "voiceConversation": "",
          "nativeVoiceToVoice": ""
        },
        "tools": "1/4"
      },
      "memoryHistory": {
        "memory": "1/2",
        "chatHistory": ""
      },
      "apps": {
        "ios": "",
        "android": "",
        "mac": "",
        "windows": ""
      },
      "other": {
        "notes": "",
        "trainingDataSharingPolicy": "",
        "trainingDataSharingPolicySource": ""
      }
    },
    "_meta": {
      "filePath": "meta-ai.mdx",
      "fileName": "meta-ai.mdx",
      "directory": ".",
      "extension": "mdx",
      "path": "meta-ai"
    },
    "title": "Meta AI",
    "author": "Benched.ai Editorial Team",
    "body": "var Component=(()=>{var u=Object.create;var s=Object.defineProperty;var _=Object.getOwnPropertyDescriptor;var d=Object.getOwnPropertyNames;var f=Object.getPrototypeOf,j=Object.prototype.hasOwnProperty;var l=(n,t)=>()=>(t||n((t={exports:{}}).exports,t),t.exports),p=(n,t)=>{for(var o in t)s(n,o,{get:t[o],enumerable:!0})},a=(n,t,o,c)=>{if(t&&typeof t==\"object\"||typeof t==\"function\")for(let r of d(t))!j.call(n,r)&&r!==o&&s(n,r,{get:()=>t[r],enumerable:!(c=_(t,r))||c.enumerable});return n};var M=(n,t,o)=>(o=n!=null?u(f(n)):{},a(t||!n||!n.__esModule?s(o,\"default\",{value:n,enumerable:!0}):o,n)),C=n=>a(s({},\"__esModule\",{value:!0}),n);var m=l((D,i)=>{i.exports=_jsx_runtime});var g={};p(g,{default:()=>h});var e=M(m());function x(n){let t={h1:\"h1\",p:\"p\",...n.components};return(0,e.jsxs)(e.Fragment,{children:[(0,e.jsx)(t.h1,{children:\"Meta AI\"}),`\n`,(0,e.jsx)(t.p,{children:\"Content for Meta AI.\"})]})}function h(n={}){let{wrapper:t}=n.components||{};return t?(0,e.jsx)(t,{...n,children:(0,e.jsx)(x,{...n})}):x(n)}return C(g);})();\n;return Component;",
    "slug": "meta-ai",
    "readingTime": "1 min read"
  }
]